import { adminGet } from './useAdminCore';
export function useAdminReferrals() {
    function getReferrals(onSuccess) {
        adminGet('/Customers/Referrals', onSuccess);
    }
    return { getReferrals };
}
